// src/components/RegisterForm.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signup } from '../actions/authAction';


function RegisterForm() {
  const dispatch = useDispatch();
  const authError = useSelector(state => state.auth.error);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [serverError, setServerError] = useState('');

  console.log('authError', authError);

  
  const errorTranslations = {
    // exact key must match whatever firstMsg is
    "A user with this email already exists.": 
    "هذا البريد الإلكتروني مستخدم من قبل",
    "user accounts with this email already exists.": 
    "هذا البريد الإلكتروني مستخدم من قبل",
    // …any other messages
  };
  
  
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    re_password: '',
  });
  
  const [showPass, setShowPass] = useState(false);
  const [showRePass, setShowRePass] = useState(false);
  
  const { username, email, password, re_password } = formData;
  useEffect(() => {
    if (!authError) return;
    let msg = '';
    if (Array.isArray(authError.email)) {
      msg = authError.email[0] || '';
    } else if (typeof authError === 'string') {
      msg = authError;
    }
    // Only update the serverError here
    setServerError(errorTranslations[msg] ?? msg);
  }, [authError]);
  
  console.log('errorMessage', errorMessage);
  useEffect(() => {
    if (password !== re_password) {
      setPasswordError('كلمة السر غير متطابقة');
    } else if (password.length < 8) {
      setPasswordError('كلمة السر يجب ان تكون 8 خانات على الاقل');
    } else {
      setPasswordError('');
    }
  }, [password, re_password]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);
  
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });


  const onSubmit = async e => {
    e.preventDefault();
    setHasSubmitted(true);
    console.log('does it submit',  hasSubmitted);
    // don't dispatch if we have a client-side error
    if (errorMessage) return;

    setIsSubmitting(true);
    setHasSubmitted(true);
    try {
      // assume your thunk returns a promise
      await dispatch(signup(username, email, password, re_password));
    } finally {
      setIsSubmitting(false);
    }
  };
  console.log('error', authError);
  console.log('this is the error', errorMessage);



  return (
    <div>
      <h2 className='title'>انشاء حساب</h2>
      {hasSubmitted && (passwordError || serverError) && (
          <p style={{ color: 'red' }}>
            {passwordError || serverError}
          </p>
        )}

      <form onSubmit={onSubmit}>
        <div>
          <label>الاسم</label>
          <input
            name="username"
            value={username}
            onChange={onChange}
          />
        </div>

        <div>
          <label>اسم الحساب</label>
          <input
            type='email'
            name="email"
            value={email}
            onChange={onChange}
          />
        </div>

        {/* Password Field */}
        <div>
          <label>كلمة السر</label>
          <div className="password-wrapper">
            <input
              className="password-field"
              name="password"
              type={showPass ? 'text' : 'password'}
              value={password}
              onChange={onChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPass(!showPass)}
            >
              {showPass ? 'اخفاء' : 'اظهار'}
            </button>
          </div>
        </div>

        {/* Confirm Password Field */}
        <div>
          <label>تاكيد كلمة السر</label>
          <div className="password-wrapper">
            <input
              className="password-field"
              name="re_password"
              type={showRePass ? 'text' : 'password'}
              value={re_password}
              onChange={onChange}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowRePass(!showRePass)}
            >
              {showRePass ? 'اخفاء' : 'اظهار'}
            </button>
          </div>
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={!!errorMessage || isSubmitting}
        >
          {isSubmitting ? 'جارٍ التسجيل…' : 'تسجيل'}
        </button>
      </form>
    </div>
  );
}

export default RegisterForm;
